if (!customElements.get('collection-promo-block')) {
  customElements.define(
    'collection-promo-block',
    class CollectionPromoBlock extends HTMLElement {
      constructor() {
        super();
        this.collectionTemplate = document.querySelector('[data-collection-section]');
        this.filters = this.querySelectorAll('[data-collection-filter]');
        if (this.filters.length === 0) return;
      }

      connectedCallback() {
        this.filters.forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
            const url = item.href;
            this.changeCollectionMainContent(url);
            history.pushState({}, '', url);
          });
        });
      }

      changeCollectionMainContent(url) {
        fetch(url)
          .then((res) => res.text())
          .then((data) => {
            const html = new DOMParser().parseFromString(data, 'text/html');
            const destination = document.querySelector('[data-collection-section]');
            const source = html.querySelector('[data-collection-section]');
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }
          });
      }
    },
  );
}
